import { Component,
         OnInit }                   from '@angular/core';
import { MatDialogRef }              from '@angular/material';
import { Globals }                  from './../common/globals';
import { KitchenModel }             from './../kitchen-list/kitchen.model';

@Component({
  selector: 'sa-kitchen-dialog',
  template: require('./kitchen-dialog.component.html'),
  styles: [require('./kitchen-dialog.component.scss')]
})
export class KitchenDialogComponent implements OnInit {

  public newItem = false;
  public model = new KitchenModel();
  private trains = [];
  private peaks = [];

  private errors = [];
  private kitchenTypes = [];
  private dataReady = false;

  constructor(
    public dialogRef: MatDialogRef<KitchenDialogComponent>,
    public globals: Globals
  ) {
      this.kitchenTypes.push({'kitchenType': 0, 'kitchenTypeName': 'Standardní'});
      this.kitchenTypes.push({'kitchenType': 1, 'kitchenTypeName': 'Lůžková'})
  }

  public delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?\nTato změna je nevratná.')) {
      this.dialogRef.close('delete');
    }
  }

  public save() {
    this.errors = [];
    if (!this.model.name || this.model.name.length === 0) {
        this.errors.push('Zadejte prosím jméno kuchyňky');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/kitchen-dialog/kitchen-dialog.component.ts